import { render, staticRenderFns } from "./200_Welcome.vue?vue&type=template&id=dff09268&scoped=true&lang=pug"
var script = {}
import style0 from "./200_Welcome.vue?vue&type=style&index=0&id=dff09268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff09268",
  null
  
)

export default component.exports